import {
  FilterChips,
  ListSection,
  PageHeader,
  PageHero,
  Screen
} from '@/shared/ui/Layout'
import {
  PageFilterChipsSkeleton,
  PageHeroSkeleton,
  PageListScreenSkeleton
} from '@/shared/ui/Skeleton'

import { QuizListCard } from './components/QuizListCard'
import { QuizzesListEmpty } from './components/QuizzesListEmpty'
import { useQuizzesListView } from './hooks/useQuizzesListView'

export const DigitalProductsQuizzes = () => {
  const {
    filter,
    setFilter,
    items,
    visibleFilters,
    groups,
    featuredQuiz,
    globalProgress,
    isEmpty,
    isFilteredEmpty,
    isLoading
  } = useQuizzesListView()

  return (
    <Screen>
      <Screen.Context className="mb-4">
        <PageHeader title="Quizzes" />

        {isLoading && <PageHeroSkeleton withProgress className="mb-0" />}

        {!isLoading && !isEmpty && (
          <PageHero
            art="/quizzes/hero-art.png"
            backgroundImage="/quizzes/hero-bg.jpg"
            artFit="contain"
            className="mb-0"
          >
            <PageHero.Title>Teste seus conhecimentos</PageHero.Title>
            <PageHero.ProgressRow
              layout="stacked"
              value={globalProgress.percent}
              label={`${globalProgress.completed} de ${globalProgress.total} concluídos`}
            />
          </PageHero>
        )}
      </Screen.Context>

      <Screen.Sticky>
        {isLoading && <PageFilterChipsSkeleton />}
        {!isLoading && !isEmpty && (
          <FilterChips
            options={visibleFilters}
            value={filter}
            onChange={setFilter}
            aria-label="Filtrar quizzes"
          />
        )}
      </Screen.Sticky>

      <Screen.Content className="pt-4">
        {isLoading && (
          <PageListScreenSkeleton
            itemCount={3}
            aria-label="Carregando quizzes"
          />
        )}

        {!isLoading && isEmpty && <QuizzesListEmpty />}

        {!isLoading && isFilteredEmpty && (
          <QuizzesListEmpty
            filtered
            onClearFilter={() => setFilter('all')}
          />
        )}

        {/* Em "Todos": destaque acima, seções pela ordem canônica. Substitui
            seis listas montadas à mão no próprio JSX. */}
        {!isLoading && !isEmpty && !isFilteredEmpty && filter === 'all' && (
          <div className="flex flex-col gap-5">
            {featuredQuiz && <QuizListCard quiz={featuredQuiz} featured />}

            {groups.map(group => (
              <ListSection
                key={group.status}
                id={`quizzes-section-${group.status}`}
                title={group.label}
                count={group.items.length}
                status={group.status}
              >
                {group.items.map(quiz => (
                  <QuizListCard key={quiz.id} quiz={quiz} />
                ))}
              </ListSection>
            ))}
          </div>
        )}

        {!isLoading && !isEmpty && !isFilteredEmpty && filter !== 'all' && (
          <div className="flex flex-col gap-3">
            {items.map(quiz => (
              <QuizListCard key={quiz.id} quiz={quiz} />
            ))}
          </div>
        )}

        {!isLoading && items.length > 0 && (
          <p
            className="text-center font-semibold text-gray-500"
            style={{
              fontSize: '0.75rem',
              letterSpacing: '0.02em',
              padding: '20px 0 40px'
            }}
          >
            Todos os quizzes carregados
          </p>
        )}
      </Screen.Content>
    </Screen>
  )
}
